import { type UseModalState } from "@clipboard-health/ui-components";

import { OpenGeoLocationBottomSheet } from "../../../OpenGeoLocation/OpenGeoLocationBottomSheet";
import {
  OpenGeoLocationProvider,
  useOpenGeoLocationContext,
} from "../../../OpenGeoLocation/useOpenGeoLocation";
import {
  ShortLeadTimeShiftBookedBottomSheet,
  type ShortLeadTimeShiftBookedBottomSheetProps,
} from "../../../Shift/BookingConfirmationBottomSheet/ShortLeadTimeShiftBookedBottomSheet";
import { type ShiftInvite } from "../types";

export interface ShiftInviteShortLeadTimeShiftBookedBottomSheetContainerProps {
  modalState: UseModalState;
  shiftInvite: ShiftInvite;
}

export function ShiftInviteShortLeadTimeShiftBookedBottomSheetContainer(
  props: ShiftInviteShortLeadTimeShiftBookedBottomSheetContainerProps
) {
  const { modalState, shiftInvite } = props;

  return (
    <OpenGeoLocationProvider
      location={{
        lat: shiftInvite.attributes.facility.geoLocation.coordinates[1],
        lng: shiftInvite.attributes.facility.geoLocation.coordinates[0],
      }}
      name={shiftInvite.attributes.facility.name}
      formattedAddress={shiftInvite.attributes.facility.fullAddress?.formatted}
    >
      <ShiftInviteShortLeadTimeShiftBookedBottomSheetWithLocation
        modalState={modalState}
        workplaceName={shiftInvite.attributes.facility.name}
      />

      <OpenGeoLocationBottomSheet />
    </OpenGeoLocationProvider>
  );
}

function ShiftInviteShortLeadTimeShiftBookedBottomSheetWithLocation(
  props: Omit<ShortLeadTimeShiftBookedBottomSheetProps, "onGetDirectionsClick" | "directionsHref">
) {
  const { href, onClick } = useOpenGeoLocationContext();

  return (
    <ShortLeadTimeShiftBookedBottomSheet
      {...props}
      directionsHref={href}
      onGetDirectionsClick={onClick}
    />
  );
}
